module.exports = __webpack_public_path__ + "img/f4c752e.jpg";